import React, { Fragment, useState } from 'react';

// Material UI
import Grid from '@mui/material/Grid';
import TablePagination from '@mui/material/TablePagination';

// Components
import Table from '../../../../components/table';
import Spinner from '../../../../components/spinner';
import { stockControllUtils } from '../../../../utils/stockControll-utils';

const columns = [
{ id: 'refId', label: 'SKU' },
{ id: 'name', label: 'Descripcion' },
{ id: 'colorCode', label: 'Color' },
{ id: 'quantity', label: 'Stock Real', align: 'center', sort: true },
{ id: 'expectedQuantity', label: 'Stock Esperado', align: 'center', sort: true },
{ id: 'differenceToShow', label: 'Diferencia', align: 'center', sort: true },
{ id: 'observation', label: 'Observaciones' }]


const StockControlDetailsTable = ({ details, loading }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <>
            { loading && <Spinner message='Cargando' /> }
            <Grid container spacing={1}>
                <Grid size={12}>
                    <Table
                        page={page}
                        rows={details.map(detail => ({
                            ...detail,
                            differenceToShow: stockControllUtils.formatDiferrence( detail?.difference )
                        }))}
                        columns={columns}
                        rowsPerPage={rowsPerPage}
                    />
                </Grid>
                <Grid size={12}>
                    <TablePagination
                        count={details.length}
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={(e, newPage) => setPage(newPage)}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Grid>
            </Grid>
        </>
    );
}

export default StockControlDetailsTable;